import { history } from "./history";
import { logException } from "../sentry.config";

export function handleResponse(response) {
  return response.text().then(text => {
    if (!response.ok) {
      switch (response.status) {
        case 400:
          /*          history.push("/404"); */
          break;
        case 500:
          const error = response.statusText;
          console.error('SERVER_ERR_500', error, 'RESPONSE:' + response, "VALUE" + text );
          logException(error, { response: response, text: text });
         
          break;
        case 404:
          history.push("/404");
          break;
        case 401:
          history.push("/login");
          break;
        default:
          break;
      }
      try {

        let data = text && JSON.parse(text);
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }
      catch{
        const error = response.statusText;
        console.error('JX_PARSE_ERROR', error, 'RESPONSE:' + response, "VALUE" + text);
        logException(error, { response: response, text: text });
        return Promise.reject(error);
      }
    }

    try {
      let escapedText = text.replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
      /*   .replace('%20', ''); */
      let data = escapedText && JSON.parse(escapedText);
      return data;
    }
    catch{
      const error = response.statusText;
      console.error('JX_PARSE_ERROR', error, 'RESPONSE:' + response, "VALUE" + text)
      logException(error, { response: response, text: text });
      return Promise.reject(error);
    }
  });
}
